import { Box, BoxProps } from '@mui/material';
import React from 'react';

/**
 * SectionContainer - Direct component wrapper for consistent section alignment
 *
 * Provides consistent margin alignment for all sections except the banner.
 * Uses the same margin-left values as the banner for visual consistency.
 * Supports background images with overlay for better text readability.
 */
interface SectionContainerProps extends BoxProps {
  children?: React.ReactNode;
}

export const SectionContainer = ({
  children,
  sx = {},
  ...props
}: SectionContainerProps) => {
  return (
    <Box
      sx={{
        // Consistent margin alignment for all sections (except banner)
        // Matches the banner alignment: xs: 3, sm: 4, md: '160px', lg: '345px'
        pl: { xs: 3, sm: 4, md: '160px', lg: '345px' },
        pr: { xs: 2, md: 4, lg: 0 },
        // Additional styling can be passed via sx prop
        ...sx,
      }}
      {...props}
    >
      <Box
        sx={{
          position: 'relative',
          zIndex: 2, // Ensure content appears above background overlay
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
